import { tv } from '../../lib/tv';

/**
 * Figma Menu (50:470), Menu Item (50:222), Menu Header (50:223) and Menu
 * Divider (50:225). Shared by Select (Radix Select) and Menu (Radix
 * DropdownMenu). Item states key on the attributes Radix sets:
 * `data-highlighted` (pointer or keyboard - Figma "Hover"),
 * `data-state="checked"` (Figma "Selected") and `data-disabled`.
 */
export const menuStyles = tv({
  slots: {
    // 240 min width (match the trigger), radius/lg, Shadow/MD, 8px padding.
    content: [
      'bg-bg-surface text-text-primary z-50 min-w-60 overflow-x-hidden overflow-y-auto',
      'rounded-lg border border-border-subtle p-2 shadow-md outline-none',
      'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
      'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
    ],
    // Height 36 for comfortable pointer + touch.
    item: [
      'relative flex h-9 w-full cursor-default items-center gap-2 rounded-sm px-2 outline-none select-none',
      'text-body-md text-text-primary',
      'data-highlighted:bg-bg-muted',
      'data-[state=checked]:bg-brand-subtle',
      'data-disabled:pointer-events-none data-disabled:text-text-disabled',
      '[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
    ],
    label: 'min-w-0 flex-1 truncate',
    shortcut: 'text-caption text-text-tertiary ml-auto',
    check: 'text-icon-brand ml-auto',
    header: 'text-overline text-text-tertiary flex h-7 items-center px-2 uppercase',
    divider:
      'flex h-[9px] items-center [&::before]:h-px [&::before]:w-full [&::before]:bg-border-subtle [&::before]:content-[""]',
    search: 'pb-1.5',
    footer: 'flex items-center justify-end gap-2 pt-1',
  },
  variants: {
    type: {
      default: {},
      // Destructive: place last, after a divider.
      danger: {
        item: 'text-status-danger-fg data-highlighted:bg-status-danger-bg data-disabled:text-text-disabled',
      },
    },
  },
  defaultVariants: { type: 'default' },
});
